import {useState} from "react";

export const useRestartSettings = () => {
    const [restartSettings, setRestartSettings] = useState({
        maxRestartAttempts: 0,
        isMaxRestartAttempts: false,
        maxLoss: 0,
        isMaxLoss: false,
        maxMinutesInTradePlan: 0,
        isMaxMinutesInTradePlan: false,
        numberOfTrades: 0,
        isNumberOfTrades: false,
        deactivateOnRestart: false
    });
    return [restartSettings, setRestartSettings];
}
